<template>
  <div v-if="show">
    <DynamicPage />
  </div>
</template>

<script lang="ts" setup>
  import { SiteStore } from '~/stores/site'
  import { WaypointResult } from '~/generated/api-clients-generated'
  import { ProactiveChat } from '~/composables/ProactiveChat'

  const { flag } = FeatureFlags.use()

  const skipPages = flag('skip-pages', [])
  const site = SiteStore.use()

  const show = ref(true)

  const { path } = AppRoute.use()

  onMounted(async () => {
    // console.log('PATH', path.value)

    const skipConfig = skipPages.value
      .filter((x) => x.journey_id === site.journey.id)
      .flatMap((x) => x.pages)
      .find((x) => x.path === path.value)

    // console.log('SKIP', skipConfig, skipPages.value)

    if (!_isNil(skipConfig)) {
      show.value = false
      const { manoeuvre } = WaypointAutoPilot.use(WaypointResult[skipConfig.result])
      await manoeuvre(skipConfig.replace)
    }

    ProactiveChat.use()
  })
</script>

<style scoped></style>
